// OrganizationDisplay.tsx
import React, { useContext, useEffect, useState } from 'react';
import { Organization } from '../types/Organization';
import { UserRoleContext } from '../context/UserRoleContext';
import { useNavigate } from 'react-router-dom';
import { getOrganizationById } from '../services/organizationService';
import { ROUTES } from '../constants/routes';


const OrganizationDisplay: React.FC = () => {
  const { userRole } = useContext(UserRoleContext);
  const organization_id = userRole?.organization_id;
  const [organization, setOrganization] = useState<Organization | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (organization_id) {
      const fetchOrg = async () => {
        const fetchedOrg = await getOrganizationById(organization_id);
        if (fetchedOrg) {
          setOrganization(fetchedOrg);
        }
      };
      fetchOrg();
    } else if (userRole?.host_id) {
      navigate(ROUTES.HOST_OVERVIEW);
    } else {
      navigate(ROUTES.HOME);
    }
  }, [organization_id]);
  if (!organization) return null;

  return (
    <div className='card' style={{maxWidth: 1000}}>
      <p><strong>Organization Name:</strong> {organization.organization_name}</p>
      <p><strong>Organization Code:</strong> {organization.organization_code}</p>
      <p><strong>Address:</strong> {organization.address1}, {organization.address2 ? organization.address2 : ''}, {organization.city}, {organization.state} {organization.zip}</p>
      <p><strong>Email:</strong> {organization.contact_email}</p>
      <p><strong>Emergency Contact:</strong> {organization.emergency_contact}</p>
      <p><strong>Emergency Phone:</strong> {organization.emergency_phone}</p>
      <p><strong>Bookkeeper Name:</strong> {organization.bookkeeper_name}</p>
      <p><strong>Bookkeeper Phone:</strong> {organization.bookkeeper_phone}</p>
      {/* <p><strong>Created At:</strong> {organization.created_at ? new Date(organization.created_at).toLocaleString() : 'N/A'}</p>
      <p><strong>Created By:</strong> {organization.created_by ? organization.created_by : 'N/A'}</p>
      <p><strong>Updated At:</strong> {organization.updated_at ? new Date(organization.updated_at).toLocaleString() : 'N/A'}</p>
      <p><strong>Updated By:</strong> {organization.updated_by ? organization.updated_by : 'N/A'}</p> */}

      {/* <div className='buttonsRow'>
        <div className='buttonsLeft'>
          <button style={{ whiteSpace: 'normal', maxWidth: '100%' }} onClick={() => navigate('/roles')}>Edit Roles for Organization</button>
          <button style={{ whiteSpace: 'normal', maxWidth: '100%' }} onClick={() => navigate(ROUTES.UPDATE_ORGANIZATION)}>Edit Organization Details</button>
          <button style={{ whiteSpace: 'normal', maxWidth: '100%' }} onClick={() => navigate(ROUTES.HOST_ORG_OVERVIEW)}>Create New Host Or Organization</button>
        </div>

      </div> */}
    </div>
  );
};

export default OrganizationDisplay;
